<template>
  <div class="camera-options-setting">
    <el-collapse v-model="activeNames" style="width: 100%">
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')"
        :title="request_prefix === 'bigScreen' ? '位置尺寸' : '位置'"
        name="1"
      >
        <div
          class="setting-item clearFloat"
          v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')"
        >
          <widthAndSizeAndZindex :options="options" :ids="ids" showSetItem="position" />
        </div>
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '8')"
        title="尺寸"
        name="8"
        v-if="request_prefix !== 'bigScreen'"
      >
        <div
          class="setting-item clearFloat"
          v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '8')"
        >
          <widthAndSizeAndZindex :options="options" :ids="ids" showSetItem="size" />
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex.vue"
export default {
  name: "camera-options-setting",
  components: { widthAndSizeAndZindex },
  props: { options: Object },
  data() {
    return {
      activeNames: ["1", "2"],
      collapseActiveNames: ["1", "2"],
      allCollapseNames: []
    }
  },
  mounted() {
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })
  },

  computed: {
    ids() {
      return this.$store.state.states.activeID
    }
  }
}
</script>

<style scoped lang="scss">
</style>
